// extracted by mini-css-extract-plugin
export default {"select":"TeamPicker_select__TB5cF"};